import React from 'react';
import { string } from 'prop-types';
import './CardLoading.scss';

CardLoading.propTypes = {
  loadingMessage: string
};

function CardLoading(props) {
  const { loadingMessage } = props;

  return (
    <div className="card__loading">
      <i className="icon-cw icon-animate-spin" />
      <div>{loadingMessage}</div>
    </div>
  );
}

export default CardLoading;
